import { useEffect, useState } from "react";
import { Timer } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";

export function AccessCountdown() {
  const { user } = useAuth();
  const { t } = useLang();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const i = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(i);
  }, []);

  if (!user || user.role === "admin" || !user.access_expires_at) return null;

  const end = new Date(user.access_expires_at).getTime();
  const diff = end - now;
  const expired = diff <= 0;

  let text;
  if (expired) {
    text = t("countdown.expired");
  } else {
    const totalSec = Math.floor(diff / 1000);
    const d = Math.floor(totalSec / 86400);
    const h = Math.floor((totalSec % 86400) / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;
    text = d >= 1
      ? `${d}d ${h}h ${m}m`
      : `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  }

  return (
    <span data-testid="access-countdown"
      title={t("countdown.title")}
      className={`hidden xs:flex sm:flex items-center gap-1 px-2 py-1 rounded-full text-[11px] font-semibold tabular-nums ${expired ? "bg-red-500/15 text-red-500" : "bg-amber-500/15 text-amber-600"}`}>
      <Timer size={12} /> {text}
    </span>
  );
}
